module.exports = __webpack_public_path__ + "static/media/damage_bg.2e689875.svg";